import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

import getCDNImagePath from '../../../Utils/getCDNImagePath';

export default function RenkiAuthIcon(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <image height="24" href={getCDNImagePath('renki/renkilogo_auth.png')} width="24" />
        </SvgIcon>
    );
}
